/* Revival Sale Manager -- storefront adapter for Recharge and Rebuy-generated markup.
   Liquid handles static cards. Do not use DOM price text as the source for Shopify checkout.
   Storefront numbers are illustrative; Shopify's automatic discounts own the actual charge.
*/
(function () {
  'use strict';
  var configNode = document.getElementById('revival-sale-config');
  if (!configNode) return;
  var settings;
  try { settings = JSON.parse(configNode.textContent || 'null'); } catch (_err) { settings = null; }
  var advancedNode = document.getElementById('revival-sale-advanced-config');
  var advanced;
  try { advanced = advancedNode ? JSON.parse(advancedNode.textContent || 'null') : null; } catch (_err) { advanced = null; }
  // Checkout and storefront publication are separate. Plesk must explicitly set
  // storefront_ready ONLY AFTER the live Function discount is verified active.
  var advancedActive = !!(advanced && advanced.version === 2 && advanced.enabled === true && advanced.storefront_ready === true);
  // Total-savings subscriptions need a verified regular/plan-price pair, not a
  // percentage off the already-discounted Recharge label. Never fabricate one.
  // Backend publication of total mode must remain blocked until end-to-end certified.
  var advancedTotalSubscription = advancedActive && advanced.subscriptionMode === 'total';
  // Verified Liquid selling-plan allocations; never infer a first-cycle price
  // from an unrelated Recharge plan. Present only when all prices agree.
  var totalPlanRows = {};
  if (advancedTotalSubscription) {
    try {
      totalPlanRows = JSON.parse(document.getElementById('revival-sale-total-plan-data')?.textContent || '{}');
    } catch (_ignore) { totalPlanRows = {}; }
  }
  if (!advancedActive && (!settings || !settings.one_time || !settings.subscription || !settings.scope)) return;
  var context = document.getElementById('revival-sale-product-context');
  var productEligible = !!context && (advancedActive || context.getAttribute('data-rsm-eligible') === 'true');
  var variantRates = {};
  if (advancedActive) {
    try { variantRates = JSON.parse(document.getElementById('revival-sale-variant-rates')?.textContent || '{}'); }
    catch (_err) { variantRates = {}; }
  }
  var decimalPrice = /(?:\d{1,3}(?:[,\s]\d{3})+|\d+)(?:[.,]\d{2})?/;
  var lastRecharge = new WeakMap();
  var lastRebuy = new WeakMap();
  var lastBenefit = new WeakMap();
  var saleEnabled = advancedActive || !!(settings.one_time.enabled || settings.subscription.enabled);
  if (!saleEnabled) return;

  var notifiedVariantId = null;
  // Product forms can contain more than one `name="id"` field. Some are hidden
  // or temporarily stale while Recharge replaces its purchase-options widget.
  // Advanced rules must never resolve an arbitrary ID to 0% just because it
  // appears first. Accept only an actual variant in Liquid's verified rate map.
  function activeVariantId() {
    if (!context) return null;
    function knownVariant(value) {
      var match = String(value || '').trim().match(/^(?:gid:\/\/shopify\/ProductVariant\/)?([1-9]\d*)$/);
      var id = match && match[1];
      return id && Object.prototype.hasOwnProperty.call(variantRates, id) ? id : null;
    }
    var resolved = knownVariant(notifiedVariantId);
    if (resolved) return resolved;
    resolved = knownVariant(new URLSearchParams(location.search).get('variant'));
    if (resolved) return resolved;
    var fields = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]:checked, form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]:not([disabled])');
    for (var i = 0; i < fields.length; i++) {
      resolved = knownVariant(fields[i].value);
      if (resolved) return resolved;
    }
    return knownVariant(context.getAttribute('data-rsm-initial-variant-id'));
  }
  function rateForVariant(variantId, mode) {
    var rates = variantRates[String(variantId)] || null;
    if (!rates) return 0; // Missing variant context is never an implied global discount.
    var n = Number(rates[mode]);
    return Number.isFinite(n) && n > 0 && n <= 100 ? n : 0;
  }
  window.RevivalAdvancedSale = {
    active: advancedActive,
    rateForVariant: rateForVariant,
    notifyVariant: function (id) {
      notifiedVariantId = String(id || '');
      if (typeof schedule === 'function') schedule();
    }
  };

  // Rebuy does not expose reliable collection membership or selling-plan prices.
  // Only safe explicit product/variant one-time overrides are rendered there.
  function rebuyAdvancedPercent(productId, variantId, mode) {
    if (mode !== 'one_time' || !productId || !variantId) return 0;
    var p = String(productId).startsWith('gid://') ? String(productId) : 'gid://shopify/Product/' + productId;
    var v = String(variantId).startsWith('gid://') ? String(variantId) : 'gid://shopify/ProductVariant/' + variantId;
    var rules = Array.isArray(advanced.rules) ? advanced.rules : [];
    if (rules.some(function (r) { return (r.type === 'exclude_product' && r.id === p) || (r.type === 'exclude_variant' && r.id === v); })) return 0;
    var matches = rules.filter(function (r) { return (r.type === 'variant' && r.id === v) || (r.type === 'product' && r.id === p); });
    matches.sort(function (a, b) { var ranks = {variant:3,product:2}; return ranks[b.type] - ranks[a.type] || (Number(b.priority)||0) - (Number(a.priority)||0) || String(a.id).localeCompare(String(b.id)); });
    for (var i=0; i<matches.length; i++) {
      if (typeof matches[i].one_time === 'number') return matches[i].one_time > 0 && matches[i].one_time <= 100 ? matches[i].one_time : 0;
    }
    if (rules.some(function (r) { return r.type === 'collection'; })) return 0; // Unknown collection membership.
    var global = advanced.global && advanced.global.one_time;
    return typeof global === 'number' && global > 0 && global <= 100 ? global : 0;
  }
  function percentFor(mode, productId, variantId) {
    if (advancedTotalSubscription && mode === 'subscription') return 0;
    if (advancedActive) {
      if (productId) return rebuyAdvancedPercent(productId, variantId, mode);
      return rateForVariant(activeVariantId(), mode);
    }
    var row = settings[mode];
    return row && row.enabled ? Number(row.percent) || 0 : 0;
  }
  // Total savings use the ORIGINAL Shopify variant price, never the
  // Recharge-adjusted price. A missing plan or different GBP amount fails closed.
  function firstCycleTotalPrice(variantId, firstPriceCents, rate, planId) {
    if (!advancedTotalSubscription || !Number.isSafeInteger(firstPriceCents) || firstPriceCents <= 0 ||
        !Number.isFinite(rate) || rate <= 0 || rate > 99) return null;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active && window.Shopify.currency.active !== 'GBP') return null;
    var p = totalPlanRows[String(variantId)];
    var variantGid = 'gid://shopify/ProductVariant/' + variantId;
    if (!p || !Number.isSafeInteger(p.regularCents) || p.regularCents <= 0 || !Array.isArray(p.plans) || !p.plans.length) return null;
    var regularText = advanced?.regularUnitPrices?.[variantGid]?.GBP;
    var expected = advanced?.expectedPlanUnitPrices?.[variantGid];
    if (typeof regularText !== 'string' || !expected || readCents(regularText) !== p.regularCents) return null;
    var planList = p.plans.filter(function (entry) {
      return entry && typeof entry.id === 'string' && Number.isSafeInteger(entry.priceCents) && entry.priceCents > 0 &&
        expected['gid://shopify/SellingPlan/' + entry.id]?.GBP &&
        readCents(expected['gid://shopify/SellingPlan/' + entry.id].GBP) === entry.priceCents;
    });
    // If Liquid sees an unpinned plan, never guess that the widget selected a pinned one.
    if (planList.length !== p.plans.length) return null;
    var chosen = planId ? planList.find(function (entry) { return entry.id === String(planId); }) : null;
    if (planId && !chosen) return null;
    if (!chosen) {
      // Recharge has no reliable selected-plan ID on some layouts. Only when
      // ALL available plans have exactly the same verified first price can
      // their choice be ignored without mispricing.
      if (!planList.every(function (entry) { return entry.priceCents === firstPriceCents; })) return null;
      chosen = planList[0];
    }
    if (chosen.priceCents !== firstPriceCents) return null;
    var bp = Math.round(rate * 100);
    if (Math.abs(bp - rate*100) > 1e-8) return null;
    var target = Math.round(p.regularCents * (10000-bp) / 10000);
    return target < firstPriceCents && target >= 0 ? target : null;
  }
  function selectedRechargePlanId() {
    var inputs = document.querySelectorAll('.rc-widget select[name="selling_plan"], .rc-widget input[name="selling_plan"]:checked');
    for (var i=0;i<inputs.length;i++) {
      var m=String(inputs[i].value||'').match(/^(?:gid:\/\/shopify\/SellingPlan\/)?([1-9]\d*)$/);
      if (m) return m[1];
    }
    return null;
  }
  function displayTotal(el, original, base, target, record, option) {
    if (target === null || target === base) return;
    var result = formatted(target, original);
    if (el.textContent.trim() !== result) el.textContent = result;
    var compare=ensureRechargePriceGroup(option,el);
    if (compare) compare.textContent=formatted(base,original);
    record.rendered=result;
  }
  function calculate(cents, pct) {
    // Mirror the two verified Shopify GBP checkout cases: percentage discount
    // is truncated to whole pennies before subtraction, not rounded on final price.
    // Basis points avoid binary floating-point drift at 2-decimal percentages.
    var basisPoints = Math.round(Number(pct) * 100);
    if (!Number.isSafeInteger(cents) || cents < 0 || !Number.isInteger(basisPoints) ||
        basisPoints < 0 || basisPoints > 10000) return cents;
    return cents - Math.floor(cents * basisPoints / 10000 + 1e-9);
  }
  function readCents(s) {
    var m = String(s || '').match(decimalPrice);
    if (!m) return null;
    var value = m[0].replace(/\s/g,'');
    if (value.indexOf(',') !== -1 && value.indexOf('.') === -1) {
      // Comma as decimal separator only when last comma has two trailing digits.
      value = /,\d\d$/.test(value) ? value.replace(/,/g,'.') : value.replace(/,/g,'');
    } else { value = value.replace(/,/g,''); }
    var n = Number(value);
    return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null;
  }
  function formatted(cents, original) {
    // Shopify's theme money formatter respects the configured money format and currency.
    try {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        var asHtml = window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
        var holder = document.createElement('span');
        holder.innerHTML = asHtml;
        return holder.textContent.trim();
      }
    } catch (_ignore) { }
    var match = String(original).match(decimalPrice);
    return match ? String(original).replace(match[0], (cents / 100).toFixed(2)) : (cents / 100).toFixed(2);
  }
  // Recharge builds its option labels dynamically. Preserve its original price node
  // (and all Recharge attributes/event bindings), but group both prices for layout.
  // This is idempotent when the MutationObserver runs again after we move the node.
  function ensureRechargePriceGroup(option, priceEl) {
    var group = priceEl.parentElement;
    if (!group || !group.classList.contains('rsm-promotional-price-group')) {
      var host = priceEl.parentNode;
      if (!host) return null;
      group = document.createElement('div');
      group.className = 'rsm-promotional-price-group';
      host.insertBefore(group, priceEl);
      group.appendChild(priceEl);
    }
    var compare = group.querySelector('.rsm-promotional-compare');
    if (!compare) {
      // Reuse a compare node from the previous adapter instead of duplicating it.
      compare = option.querySelector('.rsm-promotional-compare');
      if (!compare) {
        compare = document.createElement('s');
        compare.className = 'rsm-promotional-compare';
        compare.setAttribute('aria-label', 'Price before additional promotion');
      }
      // Original struck-through price immediately precedes the new selling price.
      group.insertBefore(compare, priceEl);
    }
    return compare;
  }
  function display(el, original, oldCents, percentage, record, container, recharge) {
    var discounted = calculate(oldCents, percentage);
    var newText = formatted(discounted, original);
    if (!newText || discounted === oldCents) return;
    if (el.textContent.trim() !== newText) el.textContent = newText;
    var compare = recharge ? ensureRechargePriceGroup(container, el) : container.querySelector('.rsm-promotional-compare');
    if (!compare && !recharge) {
      compare = document.createElement('s');
      compare.className = 'rsm-promotional-compare';
      compare.setAttribute('aria-label','Price before additional promotion');
      el.insertAdjacentElement('afterend', compare);
    }
    if (!compare) return;
    var originalDisplay = formatted(oldCents, original);
    if (compare.textContent !== originalDisplay) compare.textContent = originalDisplay;
    record.rendered = newText;
  }
  // Keep Recharge's marketing text aligned with the *additional* subscription
  // promotion configured in Sale Manager. Recharge's own first-order/renewal
  // discounts are separate; we never alter the long-term 10% claim here.
  // Theme.js inserts .subsave_append and .one--time_append asynchronously, and
  // Recharge may rerender its radio labels, so this runs on every DOM update.
  function restoreBenefit(el) {
    var saved = el && lastBenefit.get(el);
    if (saved && el.textContent !== saved.text) el.textContent = saved.text;
    var tail = el && el.nextSibling;
    if (saved && saved.tail != null && tail && tail.nodeType === 3 && tail.textContent !== saved.tail) tail.textContent = saved.tail;
  }
  function updateRechargeOfferCopy() {
    if (!productEligible) return;
    var pct = advancedTotalSubscription ? rateForVariant(activeVariantId(), 'subscription') : percentFor('subscription');
    // Only claim Total savings if Recharge's visible first-cycle price can be
    // matched to EVERY pinned plan price for the selected variant.
    if (advancedTotalSubscription) {
      var rsmSub = document.querySelector('.rc-widget .rc_widget__option--subsave .rc-option__price, .rc-widget .rc-widget__option--subsave .rc-option__price');
      var record = rsmSub && lastRecharge.get(rsmSub);
      var base = rsmSub && readCents(record ? record.base : rsmSub.textContent);
      if (!Number.isSafeInteger(base) || firstCycleTotalPrice(activeVariantId(),base,pct,selectedRechargePlanId()) === null) pct=0;
    }
    if (!Number.isFinite(pct) || pct <= 0 || pct > 100) {
      if (advancedActive) {
        document.querySelectorAll('.rc-widget .rc-option__discount, .rc-widget .rc_widget__option__discount, .rc-widget .subsave_append span.bold, .rc-widget .one--time_append span.bold').forEach(restoreBenefit);
      }
      return;
    }

    var cycles = advancedActive ? 1 : Number(settings.subscription.cycles);
    if (!Number.isFinite(cycles) || cycles < 0) cycles = 1;
    var percentText = String(pct) + '%';

    function updateFirstBenefit(container, afterText) {
      if (!container) return;
      var firstBenefit = Array.prototype.find.call(container.querySelectorAll('span.bold'), function (el) {
        return /\b(?:extra\s+)?\d+(?:\.\d+)?\s*%\s*off\b/i.test(el.textContent);
      });
      if (!firstBenefit) return;
      if (!lastBenefit.has(firstBenefit)) lastBenefit.set(firstBenefit, {
        text:firstBenefit.textContent,
        tail:firstBenefit.nextSibling && firstBenefit.nextSibling.nodeType === 3 ? firstBenefit.nextSibling.textContent : null
      });
      var value = (advancedTotalSubscription ? 'Total ' : 'Extra ') + percentText + ' Off ';
      if (firstBenefit.textContent !== value) firstBenefit.textContent = value;
      var next = firstBenefit.nextSibling;
      if (next && next.nodeType === 3 && afterText && next.textContent !== afterText) {
        next.textContent = afterText;
      }
    }

    document.querySelectorAll('.rc-widget .rc_widget__option--subsave, .rc-widget .rc-widget__option--subsave').forEach(function (option) {
      // Recharge owns the rest of the label and the native 10% renewal terms.
      var badge = option.querySelector('.rc-option__discount, .rc_widget__option__discount');
      if (badge) {
        var badgeText = advancedTotalSubscription ? percentText + ' on your first order' : 'extra ' + percentText;
        if (!lastBenefit.has(badge)) lastBenefit.set(badge, {text:badge.textContent});
        if (badge.textContent.trim() !== badgeText) badge.textContent = badgeText;
      }

      var subCopy = option.querySelector('.subsave_append');
      var subTrailing = cycles === 1 ? ' your first order and ' :
        (cycles === 0 ? ' every subscription order, plus ' :
          ' your first ' + cycles + ' subscription orders, then ');
      updateFirstBenefit(subCopy, subTrailing);
    });

    // The unselected one-time option also promotes the subscription offer.
    // Synchronize that copy so switching purchase modes never shows 20% again.
    document.querySelectorAll('.rc-widget .rc_widget__option--onetime, .rc-widget .rc-widget__option--onetime').forEach(function (option) {
      var oneCopy = option.querySelector('.one--time_append');
      var oneTrailing = cycles === 1 ? ' your first order, then ' :
        (cycles === 0 ? ' on every subscription order, plus ' :
          ' on your first ' + cycles + ' subscription orders, then ');
      updateFirstBenefit(oneCopy, oneTrailing);
    });
  }

  function updateRecharge() {
    if (!productEligible) return;
    updateRechargeOfferCopy();
    var options = document.querySelectorAll('.rc-widget .rc_widget__option, .rc-widget .rc-widget__option');
    var cheapest = null;
    options.forEach(function (option) {
      var mode = option.classList.contains('rc_widget__option--subsave') || option.classList.contains('rc-widget__option--subsave') ? 'subscription' :
        (option.classList.contains('rc_widget__option--onetime') || option.classList.contains('rc-widget__option--onetime') ? 'one_time' : null);
      if (!mode) return;
      var priceEl = option.querySelector('.rc-option__price');
      if (!priceEl) return;
      var pct = percentFor(mode);
      var totalPct = advancedTotalSubscription && mode === 'subscription' ? rateForVariant(activeVariantId(),'subscription') : 0;
      var currentText = priceEl.textContent.trim();
      var record = lastRecharge.get(priceEl);
      // Recharge can replace text on variant/plan selection. Rebase ONLY on an external change.
      if (!record || (currentText !== record.rendered && currentText !== record.base)) {
        record = {base:currentText, rendered:null};
        lastRecharge.set(priceEl, record);
      }
      var cents = readCents(record.base);
      if (cents === null || cents === 0) return;
      var targetTotal = totalPct > 0 ? firstCycleTotalPrice(activeVariantId(), cents, totalPct, selectedRechargePlanId()) : null;
      if (targetTotal !== null) displayTotal(priceEl, record.base, cents, targetTotal, record, option);
      else if (pct) display(priceEl, record.base, cents, pct, record, option, true);
      else if (advancedActive) {
        if (priceEl.textContent.trim() !== record.base) priceEl.textContent = record.base;
        var priceGroup = priceEl.closest('.rsm-promotional-price-group');
        if (priceGroup) {
          var strike = priceGroup.querySelector('.rsm-promotional-compare');
          if (strike) strike.remove();
          priceGroup.parentNode.insertBefore(priceEl, priceGroup);
          priceGroup.remove();
        }
        record.rendered = null;
      }
      var actual = targetTotal !== null ? targetTotal : (pct ? calculate(cents,pct) : cents);
      if (cheapest === null || actual < cheapest) cheapest = actual;
    });
    if (cheapest !== null && context) {
      var sticks = Number(context.getAttribute('data-rsm-stick-count'));
      if (sticks > 0) {
        var titlePerStick = document.querySelector('.product-single__meta > .totle_stick > span');
        if (titlePerStick) {
          var n = Math.ceil(cheapest / sticks);
          var next = formatted(n, titlePerStick.textContent);
          if (titlePerStick.textContent !== next) titlePerStick.textContent = next;
        }
      }
    }
  }
  function updateRebuy() {
    // Rebuy's recommendations are dynamic. For selected collections the widget doesn't
    // expose reliable collection memberships, so fail closed instead of mispricing.
    if (!advancedActive && settings.scope.type !== 'all') return;
    document.querySelectorAll('.rebuy-product-price[data-rsm-base-cents]').forEach(function (node) {
      var mode = node.getAttribute('data-rsm-mode');
      var pct = percentFor(mode, advancedActive ? node.getAttribute('data-rsm-product-id') : null,
        advancedActive ? node.getAttribute('data-rsm-variant-id') : null);
      var base = Number(node.getAttribute('data-rsm-base-cents'));
      if (!Number.isFinite(base) || base <= 0) return;
      var el = node.querySelector('.rebuy-money:not(.compare-at) > span:last-child');
      if (!el) return;
      if (!pct) {
        if (advancedActive) {
          var last = lastRebuy.get(el);
          if (last && last.rendered && el.textContent.trim() === last.rendered) {
            el.textContent = formatted(base, last.text);
            var createdStrike = node.querySelector('.rsm-promotional-compare');
            if (createdStrike) createdStrike.remove();
            lastRebuy.delete(el);
          }
        }
        return;
      }
      var old = lastRebuy.get(el);
      var existingText = el.textContent.trim();
      // Use the price from Rebuy's Vue binding, never discount our previously rendered value.
      if (!old || old.base !== base || old.mode !== mode || (existingText !== old.rendered && existingText !== old.text)) {
        old = {base:base, mode:mode, text:existingText, rendered:null};
        lastRebuy.set(el,old);
      }
      var nativeCompare = node.querySelector('.rebuy-money.compare-at > span:last-child');
      if (nativeCompare) {
        var saleText = formatted(calculate(base,pct),old.text);
        var baseText = formatted(base,old.text);
        if (el.textContent.trim() !== saleText) el.textContent = saleText;
        if (nativeCompare.textContent.trim() !== baseText) nativeCompare.textContent = baseText;
        old.rendered = saleText;
      } else {
        display(el, old.text, base, pct, old, node);
      }
    });
  }
  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      updateRecharge();
      updateRebuy();
    }, 90);
  }
  function start() {
    schedule();
    // Child/text mutations are needed because Recharge and Rebuy hydrate after DOM load.
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-rsm-base-cents','data-rsm-mode'] });
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();